<template>
  <Dropdown
    class="cascader-multi"
    :class="{root}"
    :placement="root ? 'bottom' : 'right-start'"
    :trigger="root ? 'click' : 'hover'"
  >
    <Input
      v-if="root"
      :value="inputShow"
      :title="inputShow"
      @on-change="onInputClear"
      placeholder="请选择"
      readonly
      clearable
    ></Input>
    <DropdownItem v-else>
      {{data.label}}
      <Icon type="ios-arrow-forward"></Icon>
    </DropdownItem>
    <DropdownMenu slot="list">
      <template v-for="(item, index) in menuData">
        <cascader-multi
          :key="index"
          v-if="item.children && item.children.length"
          :data="item"
          :root="false"
          @on-select="onSelect"
        ></cascader-multi>
        <Checkbox
          :key="index"
          class="item-checkbox"
          v-else
          v-model="item.checked"
          @on-change="onSelect($event, item)"
        >{{item.label}}</Checkbox>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
export default {
  name: "cascader-multi",
  props: {
    // 数据集合
    data: {
      default() {
        return [];
      }
    },
    // 选中的数据
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    // 是否为根组件（内部属性，用户不必关心）
    root: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    menuData() {
      if (this.root) {
        return this.data;
      } else {
        return this.data.children;
      }
    },
    inputShow() {
      let ret = "";
      this.selection.forEach(i => {
        ret += i.label + ", ";
      });
      ret = ret.slice(0, -2);
      return ret;
    }
  },
  data() {
    return {
      selection: []
    };
  },
  watch: {
    data() {
      this.init();
    },
    value() {
      this.init();
    }
  },
  created() {},
  methods: {
    // on event
    onSelect(check, val) {
      // 如果是根，则记录数据；否则，传递给父组件
      if (this.root) {
        if (check) {
          this.selection.push(val);
        } else {
          this.selection.splice(this.selection.indexOf(val), 1);
        }
        this.emitValue();
      } else {
        this.$emit("on-select", check, val);
      }
    },
    onInputClear() {
      if (!this.root) return;
      this.selection = [];
      this.data.forEach(i => {
        this.setChecked(i, false);
      });
      this.emitValue();
    },
    // other
    init() {
      if (!this.root) return;
      this.selection = [];
      this.data.forEach(i => {
        this.setChecked(i, false);
      });
      this.initChecked(this.data);
    },
    initChecked(tmp) {
      tmp.forEach(i => {
        if (i.children && i.children.length) {
          this.initChecked(i.children);
        } else {
          if (
            this.value.filter(item => {
              return item == i.value;
            }).length
          ) {
            this.$set(i, "checked", true);
            this.selection.push(i);
          }
        }
      });
    },
    setChecked(item, checked) {
      if (item.children && item.children.length) {
        item.children.forEach(i => {
          this.setChecked(i, checked);
        });
      } else {
        this.$set(item, "checked", checked);
      }
    },
    emitValue() {
      const val = [];
      this.selection.forEach(i => {
        val.push(i.value);
      });
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss">
.cascader-multi {
  .item-checkbox {
    display: block;
    margin-left: 15px;
    // margin: 0px 10px;
  }
  .ivu-select-dropdown {
    width: auto !important;
  }
  &.root > .ivu-select-dropdown {
    left: 0 !important;
  }
}
</style>